import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Cookies from 'js-cookie';

@inject('appStore')
@observer
class Banner extends Component {

  goToNewVersion() {
    Cookies.set("is_new", 1);
    window.location.reload();
  }

  render() {
    return (
      <div className="banner">
          <div className='banner-wrapper'>
            <div className='banner-content'>
              <h2 className='banner-title'>Оцени преимущества новой версии!</h2>
              <div className='banner-card'>
                <div className='banner-card--info'>
                  <div className='banner-card--title'>
                    Удобство
                  </div>
                  <div className='banner-card--subtitle'>
                    Стабильная работа сайта,  визуализация Live-событий, темная или светлая темы
                  </div>
                </div>
                <div className='banner-card--info'>
                  <div className='banner-card--title'>
                    Игры 24/7
                  </div>
                  <div className='banner-card--subtitle'>
                    Когда нет подходящих спортивых событий 
                  </div>
                </div>
                <div className='banner-card--info'>
                  <div className='banner-card--title'>
                    Инфографика
                  </div>
                  <div className='banner-card--subtitle'>
                    Подробная визуализация LIVE-событий с минимальной задержкой
                  </div>
                </div>
              </div>
              <div className='banner-image' />
              <button className='banner-button' type='button' onClick={this.goToNewVersion}>Перейти на новую версию</button>
            </div>
            <div className='banner-close' onClick={() => this.props.hideBanner()} />
        </div>
        <div className='banner-overlay' onClick={() => this.props.hideBanner()}></div>
      </div>
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/banner/index.js